module.exports = __webpack_public_path__ + "img/icon_autism_surveillance_network.3cfb7735.svg";